import React, { Component } from 'react';
import { TextArea, Button } from 'components/antd';
import styles from './styles.module.scss';

interface Props {
	rows: number;
	value: string | null;
	onChange?: (note: string) => void;
}

interface State {
	isOpen: boolean;
	value: string;
}

export class DriverNote extends Component<Props, State> {
	state = {
		isOpen: false,
		value: this.props.value || '',
	};

	static defaultProps = {
		rows: 5,
	};

	onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { value } = e.currentTarget;
		this.setState(
			{
				value,
			},
			() => {
				const { onChange } = this.props;
				if (onChange) {
					onChange(this.state.value);
				}
			}
		);
	};

	toggle = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

	render() {
		const { isOpen } = this.state;
		return (
			<div>
				{!isOpen ? (
					<Button type="dashed" className={styles.notesButton} onClick={this.toggle}>
						Show notes to driver{' '}
					</Button>
				) : (
					<div className={styles.notesForm}>
						<h6 className={styles.notesTitle}>Notes to driver</h6>
						<TextArea
							className={styles.notesArea}
							rows={this.props.rows}
							value={this.state.value}
							onChange={this.onChange}
						/>
						<Button type="dashed" className={styles.notesButton} onClick={this.toggle}>
							Hide notes
						</Button>
					</div>
				)}
			</div>
		);
	}
}
